import React from 'react';
import Pagination from 'react-bootstrap/Pagination';

const Paginate = ({ postsPerPage, totalPosts, onPageChange, currentPage, previousPage, nextPage }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pageNumbers.push(i);
  }

  const displayPageNumbers = [];

  const maxPageNumbers = 1;

  if (pageNumbers.length <= maxPageNumbers) {      //12<=2
    displayPageNumbers.push(...pageNumbers);
  } else {
    const halfMaxPageNumbers = Math.floor(maxPageNumbers / 2);
    const startEllipsis = currentPage > halfMaxPageNumbers + 1;
    const endEllipsis = currentPage < pageNumbers.length - halfMaxPageNumbers;

    if (startEllipsis) {
      displayPageNumbers.push(1, '...');
    }

    const startIndex = Math.max(currentPage - halfMaxPageNumbers, 1);
    const endIndex = Math.min(currentPage + halfMaxPageNumbers, pageNumbers.length);

    for (let i = startIndex; i <= endIndex; i++) {
      displayPageNumbers.push(i);
    }

    if (endEllipsis) {
      displayPageNumbers.push('...', pageNumbers.length);
    }
  }


  return (
    <div className="pagination-container">
      <Pagination>
        <Pagination.Prev onClick={previousPage} />
        {displayPageNumbers.map((number, index) => (
          <Pagination.Item
            key={index}
            active={number === currentPage}
            onClick={() => {
              if (number !== '...') {
                onPageChange(number);
              }
            }}
          >
            {number}
          </Pagination.Item>
        ))}
        <Pagination.Next onClick={nextPage} />
      </Pagination>
    </div>
  );
};

export default Paginate;
